import { useStore } from "../../../hooks/store";
import Styles from "../Form.module.css";
import CustomField from "../../shared/CustomTextField";
import { Formik } from "formik";
import { Button } from "@mui/material";

export default function DriverPrepareForm() {
  const store = useStore();

  const initValues = {
    group: "",
    hour: null,
    price: null,
  };

  const wrapperStyle = {} && { flexDirection: "row" };
  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        store.form.dataToUpdate.getDoc(values.group, values.price, values.hour);
        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        /* and other goodies */
      }) => (
        <>
          <p>Договор на поготовку водителей</p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <CustomField
                  name="group"
                  label="№ группы"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
                <CustomField
                  name="hour"
                  label="Часы обучения"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.phone}
                />
                <CustomField
                  name="price"
                  label="Стоимость обучения"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.city}
                />
              </div>
            </div>

            <div className="form_actions">
              <Button variant="contained" onClick={handleSubmit}>
                Запросить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
